import getConfig from "next/config"
import { PHASE_PRODUCTION_BUILD , PHASE_PRODUCTION_SERVER, PHASE_DEVELOPMENT_SERVER} from "next/dist/shared/lib/constants"

export interface IPublicRuntimeConfig{
    version:string
    phase:string
}
export const publicRuntimeConfig:IPublicRuntimeConfig = getConfig() ? getConfig().publicRuntimeConfig : {
    version:"",
    phase:PHASE_DEVELOPMENT_SERVER
}
export const isBuild = publicRuntimeConfig.phase === PHASE_PRODUCTION_BUILD;
export const isServer = publicRuntimeConfig.phase === PHASE_PRODUCTION_SERVER;


export const isDev = publicRuntimeConfig.phase === PHASE_DEVELOPMENT_SERVER;